export const environment = {
  baseAPIUrl: 'https://petpets-api-dev.saviomiranda.dev'
};
